import React from 'react';
import { ApolloClient } from '@apollo/client';

export const WebsocketClientContext = React.createContext<ApolloClient<any> | undefined>(undefined);
